

import { CustomerModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { customersStore } from '@/libs/customers/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import CustomerDialog from '../components/CustomerDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        CustomerDialog
    }
})
export default class Customers extends Page {

    get headers() {
        return [
            { text: this.$i18n.t("customers.code"), value: "code", align: "left", sortable: false },
            { text: this.$i18n.t("customers.name"), value: "name", align: "left", sortable: false },
            { text: "", value: "id", align: "left", sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: CustomerDialog;

    @Watch("itemsPerPage")
    itemsPerPageChanged (v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return customersStore.useGetter(CrudGetter.Pending);
    }
    
    get categories (): CustomerModel[] {
        return [...customersStore.useGetter(CrudGetter.Data)];
    }

    get totalRows (): number {
        return ({...customersStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    mounted () {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load () {
        customersStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<CustomerModel>({ field: "name", index: 1, order: "asc" }, this.getFilters());
    }

    open (item: CustomerModel) {
        this.dialog.open(item.id!);
    }

    createItemClick () {
        this.dialog.open(Guid.EmptyGuid());
    }

}
